var exports = {
  "OL": "x93eb46d8--2987f9--vas-title",
  "d4": "x93eb46d8--2987f9--star",
  "M1": "x93eb46d8--2987f9--stats",
  "me": "x93eb46d8--2987f9--separator",
  "h_": "x93eb46d8--2987f9--description",
  "q9": "x93eb46d8--2987f9--price",
};

module.exports = exports;
